// Motivo da exclusão de usuário (pedido 2026-09-30, tela Usuários →
// Excluir) — GPS Drive Backend próprio. O usuário continua sendo excluído
// direto no rastreamento (usersService.remove); aqui fica só o registro
// de quem foi excluído, por quem e por quê. Ver user-deletions.service.ts
// no backend.
import { gpsDriveDelete, gpsDriveGet, gpsDrivePost } from "@/lib/api/gpsdrive-client";

export interface UserDeletionEntry {
  id: string;
  traccarUserId: number;
  name: string;
  email: string;
  phone: string | null;
  accountType: string | null;
  reason: string;
  deletedByUserId: string;
  deletedByName: string;
  deletedAt: string;
}

export const gpsDriveUserDeletionsService = {
  list: () => gpsDriveGet<UserDeletionEntry[]>("/api/v1/user-deletions"),
  // Chamado ANTES do DELETE do usuário — o backend copia nome/login/
  // telefone enquanto o usuário ainda existe.
  record: (traccarUserId: number, reason: string) =>
    gpsDrivePost<UserDeletionEntry>("/api/v1/user-deletions", { traccarUserId, reason }),
  // Desfaz o registro quando a exclusão em si falhou.
  cancel: (id: string) => gpsDriveDelete<void>(`/api/v1/user-deletions/${id}`),
};
